<!-- Floating Bubble -->
<button
  class="chat-bubble"
  [class.shake]="shaking"
  [class.open]="svc.isOpen"
  (click)="toggle()"
  aria-label="Toggle chat assistant">
  <span class="bubble-icon" *ngIf="!svc.isOpen">
    <i class="bi bi-chat-dots-fill"></i>
  </span>
  <span class="bubble-icon close-icon" *ngIf="svc.isOpen">
    <i class="bi bi-x-lg"></i>
  </span>
  <span class="unread-dot" *ngIf="svc.hasUnread && !svc.isOpen">
    <span class="unread-count">1</span>
  </span>
</button>

<!-- Chat Panel -->
<div class="chat-panel" *ngIf="svc.isOpen">
  <!-- Header -->
  <div class="panel-header">
    <div class="header-left">
      <div class="header-icon">
        <i class="bi bi-signpost-split-fill"></i>
      </div>
      <div class="header-text">
        <span class="header-title">SIA Helper</span>
        <span class="header-subtitle">Your Navigation Guide</span>
      </div>
    </div>
    <div class="header-actions">
      <button class="header-btn" (click)="svc.startNewChat()" title="New conversation">
        <i class="bi bi-plus-lg"></i>
      </button>
      <button class="header-btn" (click)="toggle()" title="Minimize">
        <i class="bi bi-dash-lg"></i>
      </button>
    </div>
  </div>

  <!-- Messages -->
  <div class="panel-messages" #chatBox>
    <!-- Suggestions (empty state) -->
    <div class="suggestions" *ngIf="svc.messages.length <= 1 && !svc.isLoading">
      <p class="suggestions-label">Try asking:</p>
      <button
        class="suggestion-chip"
        *ngFor="let s of suggestions"
        (click)="selectSuggestion(s)">
        <i class="bi bi-lightning-charge"></i>
        {{ s }}
      </button>
    </div>

    <!-- Messages -->
    <div
      *ngFor="let msg of svc.messages; trackBy: trackByIndex"
      class="msg-row"
      [ngClass]="msg.sender">

      <div class="msg-avatar" *ngIf="msg.sender === 'assistant'">
        <i class="bi bi-signpost-split-fill"></i>
      </div>

      <div class="msg-bubble" [ngClass]="msg.sender">
        <div [innerHTML]="msg.text"></div>

        <!-- Action Buttons -->
        <div *ngIf="msg.actions?.length" class="msg-actions">
          <button
            *ngFor="let action of msg.actions"
            class="action-btn"
            (click)="navigate(action)">
            <i class="bi" [ngClass]="getActionIcon(action)"></i>
            {{ action.label }}
            <i class="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Typing Indicator (shown only before first streamed token arrives) -->
    <div class="msg-row assistant" *ngIf="svc.isLoading && !svc.isStreaming">
      <div class="msg-avatar">
        <i class="bi bi-signpost-split-fill"></i>
      </div>
      <div class="msg-bubble assistant typing">
        <div class="typing-dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Input Bar -->
  <div class="panel-input">
    <input
      type="text"
      [(ngModel)]="userInput"
      (keyup.enter)="send()"
      placeholder="Ask about features, companies, themes..."
      [disabled]="svc.isLoading"
      autocomplete="off" />
    <button
      class="send-btn"
      (click)="send()"
      [disabled]="!userInput.trim() || svc.isLoading">
      <i class="bi bi-send-fill"></i>
    </button>
  </div>
</div>
